import _ from "lodash";

export const REQUIRED_SCOPES = [
    'pages_show_list',
    'instagram_basic',
    'pages_read_engagement'
].join(',');

export function parseXFBML(element) {
    return new Promise((res, rej) => {
        try {
            window.FB.XFBML.parse(element, res);
        } catch (e) {
            rej(e);
        }
    });
}

export function logout() {
    return window.FB.logout(() => Promise.resolve());
}

export function getUser() {
    return new Promise((resolve, reject) => {
        const callback = (response) => {
            if (!response || response.error) {
                reject(response.error);
            } else {
                resolve(response);
            }
        };

        window.FB.api('/v16.0/me?fields=first_name,picture{url}', 'GET', {}, callback);
    });
}

export function getPages() {
    return new Promise((resolve, reject) => {
        let pages = [];
        const callback = (response) => {
            if (!response || response.error) {
                reject(response.error);
            } else {
                pages = pages.concat(response.data.map(p => ({
                    id: p.id,
                    name: p.name,
                    picture: _.get(p, 'picture.data.url'),
                    igAccountId: _.get(p, 'instagram_business_account.id'),
                })));
                if (response.paging && response.paging.next) {
                    window.FB.api(response.paging.next, 'GET', {}, callback);
                } else {
                    resolve(pages);
                }
            }
        };

        window.FB.api('/v16.0/me/accounts?fields=id,instagram_business_account,name,picture{url}', 'GET', {}, callback);
    });
}



export function getIGPage(token, igAccountId) {
    return new Promise((resolve, reject) => {
        const callback = (response) => {
            if (!response || response.error) {
                reject(response.error);
            } else {
                resolve(response);
            }
        };

        window.FB.api(`/v16.0/${igAccountId}?access_token=${token}&fields=username%2Cprofile_picture_url%2Cname`, 'GET', {}, callback);
    });
}